const apiUrl = process.env.REACT_APP_API_URL;

export const DeleteJutgeCazaTest = async (idTest: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/test/${idTest}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.ok;
    } catch (error) {
        console.error('Error al eliminar el test de caza:', error);
        return false;
    }
};
